<template lang="pug">
.w-100
  navs

  .content-height
    .brands-bg
      .back-opacy
        h3.font-weight-bold.text-white.mb-0.text-shadow Novedades

    .section
      b-container
        h3.font-weight-bold.text-center Descubre las últimas noticias
        p.text-secondary.text-center.mb-0 Consulta los videos de las últimas novedades de nuestras marcas

    .section.text-center
      b-container
        h3.font-weight-bold.mb-3.text-black Killark
        b-row
          b-col.mb-3(v-for='(video, index) in Killark', :key='index', :md='12 / Killark.length')
            b-embed.video(type='iframe', :src='video', allowfullscreen)

    .section.text-center
      b-container
        h3.font-weight-bold.mb-3.text-black Appleton
        b-row
          b-col.mb-3(v-for='(video, index) in Appleton', :key='index', :md='12 / Appleton.length')
            b-embed.video(type='iframe', :src='video', allowfullscreen)

    .section.text-center
      b-container
        h3.font-weight-bold.mb-3.text-black Lumiance
        b-row
          b-col.mb-3(v-for='(video, index) in Lumiance', :key='index', :md='12 / Lumiance.length')
            b-embed.video(type='iframe', :src='video', allowfullscreen)

    .section.text-center
      b-container
        h3.font-weight-bold.mb-3.text-black Syltech
        b-row
          b-col.mb-3(v-for='(video, index) in Syltech', :key='index', :md='12 / Syltech.length')
            b-embed.video(type='iframe', :src='video', allowfullscreen)

    .section.text-center
      b-container
        h3.font-weight-bold.mb-3.text-black Tork
        b-row
          b-col.mb-3(v-for='(video, index) in Tork', :key='index', :md='12 / Tork.length')
            b-embed.video(type='iframe', :src='video', allowfullscreen)

  footer-component
</template>

<script>
import ContactForm from '@/components/ContactForm.vue'
import FooterComponent from '@/components/Footer.vue'
import Navs from '@/components/Navs.vue'

export default {
  components: { ContactForm, FooterComponent, Navs },
  data() {
    return {
      Killark: ['https://www.youtube.com/embed/M3j6ERVezdU', 'https://www.youtube.com/embed/BhrFC1n0k1g'],
      Appleton: ['https://www.youtube.com/embed/HcYWKgr22A8', 'https://www.youtube.com/embed/w2DVIfOjRDg'],
      Lumiance: ['https://www.youtube.com/embed/FvgaDDQgILg', 'https://www.youtube.com/embed/1TqHzthn7-U', 'https://www.youtube.com/embed/pwtzXmJm_WA'],
      Syltech: ['https://www.youtube.com/embed/0MxXrDUDqpE', 'https://www.youtube.com/embed/pMqRiH1JLWo'],
      Tork: ['https://www.youtube.com/embed/tKQ6M6_NVco', 'https://www.youtube.com/embed/PYLOIplCvtM'],
    }
  },
}
</script>

<style lang="scss" scoped>
@import 'bootstrap/scss/_functions.scss';
@import 'bootstrap/scss/_variables.scss';
@import 'bootstrap/scss/mixins/_breakpoints.scss';

// .video {
//   width: 350px;
//   height: 200px;
// }

.back-opacy {
  height: 100% !important;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.section {
  padding-top: 1rem;
  padding-bottom: 1rem;

  @include media-breakpoint-up(lg) {
    padding-top: 3rem;
    padding-bottom: 3rem;
  }
}

.brands-bg {
  width: 100%;
  height: 130px;
  background-image: url('~@/assets/images/4.jpg');
  background-position: center;
  background-size: cover;
}

.content-height {
  margin-top: 106px;
  min-height: calc(100vh - 106px - 177px);

  @include media-breakpoint-up(md) {
    margin-top: 112px;
    min-height: calc(100vh - 112px - 57.31px);
  }
}
</style>